import React from 'react';
import { EmptyStar, StarFilled } from './icons';
import './Score.scss';
import EndImg from '../../images/imgEnd.svg';
import { GC } from '../../services/config/gamecentreService';
import { storage } from '../../services/config/storage';

const Score = (props) => {
    const pointsScored = parseInt(props.score);
    return (
        <div className="score-container">
            <div className="score">

                {/* {props.timeTaken > 750 || pointsScored > 95 ?
                    <div className="stars">
                        <div style={{ transform: "rotate(-30deg)", marginTop: "53px" }}><StarFilled width="60px" height="60px" /></div>
                        <div><StarFilled /></div>
                        <div style={{ transform: "rotate(23deg)", marginTop: "43px", marginLeft: "3px" }}><StarFilled width="60px" height="60px" /></div>
                    </div>
                    :
                    null

                } */}
                <img style={{ marginLeft: "30px" }} src={EndImg} />
                <h2>{props.timeTaken == 0 ? "You did nothing" : "You did great!"}</h2>
                < div className="details-box">
                    <div className="info-box">
                        <div className="time">Total Points</div>
                        <div className="accuracy">{props.timeTaken}</div>
                    </div>
                    <div className="info-box">
                        <div className="time">Accuracy</div>
                        <div className="accuracy">{pointsScored}%</div>
                    </div>


                </div>
                {/* <h4>You did better than 95% players</h4> */}
                <button onClick={() => {
                    GC.sendGameEndMessage()
                    storage.destroy.all();
                }} className={`questionOptions style-4`}>
                    <span>Continue</span>
                </button>
            </div>
        </div>
    );
}

export default Score;